import type { DeleteEnterpriseRiskMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  DeleteEnterpriseRiskDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteEnterpriseRisk = createMutationHook({
  name: 'deleteEnterpriseRisk',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.enterpriseRisk.delete.mutationOptions({ onSuccess }),
  mapInput: (id: string) => ({ Id: id }),
  invalidate: (trpc) => [
    trpc.frontend.enterpriseRisk.register.queryKey(),
    trpc.frontend.enterpriseRisk.getById.queryKey(),
    trpc.frontend.enterpriseRisk.getByTier.queryKey(),
  ],
  // The tRPC delete returns no content (204); the V2 GraphQL mutation reported
  // a single affected row, which the delete page checks to unmount.
  mapResponse: (): DeleteEnterpriseRiskMutation => ({
    deleteChildEnterpriseRisk: {
      __typename: 'GenericMutationOutput',
      affected_rows: 1,
    },
  }),
  graphqlDocument: DeleteEnterpriseRiskDocument,
  graphqlVariables: (id: string) => ({ Id: id }),
  evictFields: ['enterprise_risk'],
  refetchQueries: [
    namedOperations.Query.getEnterpriseRiskById,
    namedOperations.Query.getEnterpriseRisksFlat,
    namedOperations.Query.getEnterpriseRisksByTier,
    namedOperations.Query.getEnterpriseRisks,
  ],
});
